import { onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import Cover from "../../assets/png/cover.jpg";
import Logo from "../../assets/png/logo.png";
import "./Login.css";
//Components
import Person from "@mui/icons-material/Person";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";

import { setUser } from "../../features/auth/authSlice";
import { auth } from "../../utils/firebase/firebase";
import { Typography } from "@mui/material";

// import UserContext from "../../UserContext";

const Login = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [showPassword, setshowPassword] = useState(false);
	const [passwordResetEmail, setPasswordResetEmail] = useState("");
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const handleLogIn = async () => {
		// console.log("running handleLogin Fn");
		try {
			await signInWithEmailAndPassword(auth, email, password);
		} catch (err) {
			// console.log("err :>> ", err);
			Swal.fire({
				icon: "error",
				title: "Wrong Credentials",
				text: "Please try again",
			});
		}
	};

	const handleForgotPassword = async () => {
		var host = window.location.protocol + "//" + window.location.host;
		host = host + "/login";
		const config = {
			url: host,
			handleCodeInApp: false,
		};

		if (passwordResetEmail === "" || passwordResetEmail === undefined) {
			Swal.fire({
				icon: "error",
				title: "Error",
				text: "Please enter your email to continue",
				customClass: {
					popup: "custom-popup", // Define a custom class for error popup
				},
			});
		} else {
			await auth.sendPasswordResetEmail(passwordResetEmail, config);
			Swal.fire({
				icon: "success",
				title: "Success",
				text: "Please check your email for password reset link",
				customClass: {
					popup: "custom-popup", // Define a custom class for error popup
				},
			});
			setOpen(false);
		}
	};

	const handleRegistration = (e) => {
		e.preventDefault();
		navigate("/registration");
	};

	const handleShowPassword = () => {
		setshowPassword(!showPassword);
	};

	useEffect(() => {
		const listener = onAuthStateChanged(auth, (user) => {
			if (user) {
				dispatch(
					setUser({
						email: user.email,
						uid: user.uid,
					})
				);
				navigate("/");
			}
		});

		return () => {
			listener();
		};
	}, [dispatch, navigate]);

	return (
		<>
			<div className="login-card">
				<div className="login-wrapper">
					<Grid container spacing={0}>
						{/* Left Panel */}
						<Grid container xs={7}>
							<Grid
								item
								xs={12}
								sx={{
									backgroundImage: `url(${Cover})`,
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%", // Adjust height as needed
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									paddingLeft: "32px",
									paddingRight: "32px",
								}}>
								<Typography sx={bigLetters}>Data analytics made easy</Typography>
							</Grid>
						</Grid>
						{/* Right Panel */}
						<Grid item xs={5}>
							<div className="login-form">
								<FormControl>
									<div className="login-logo-box">
										<img src={Logo} className="image" size="small" alt="logo" />
									</div>

									<div className="login-input-box">
										<p className="label">Email</p>
										<Input
											name="email"
											className="textfield"
											type="text"
											endAdornment={
												<InputAdornment position="end">
													<Person className="icon" />
												</InputAdornment>
											}
											onChange={(e) => setEmail(e.target.value)}
										/>
										<p className="label">Password</p>
										<Input
											name="password"
											className="textfield"
											type={!showPassword ? "password" : "text"}
											endAdornment={
												<InputAdornment position="end" onClick={handleShowPassword}>
													{!showPassword ? (
														<VisibilityOff className="icon" />
													) : (
														<Visibility className="icon" />
													)}
												</InputAdornment>
											}
											onChange={(e) => setPassword(e.target.value)}
										/>
										<Button variant="contained" className="login__button" onClick={handleLogIn}>
											Log In
										</Button>
									</div>
								</FormControl>
								<div className="login-forget-password">
									<label className="label-click">Reset Password?</label>
									<span className="login-fp-here" onClick={handleOpen}>
										{" "}
										Click here!
									</span>
								</div>
								<div className="login-no-account">
									<label className="label-click">No Account?</label>
									<span className="login-fp-here" onClick={handleRegistration}>
										{" "}
										Click here!
									</span>
								</div>
							</div>
						</Grid>
					</Grid>
				</div>
			</div>
			<Modal open={open} onClose={handleClose} className="password--reset">
				<div className="card--modal">
					<div className="card__container">
						<h2 className="password__title">Please enter your email to continue</h2>
						<TextField
							required
							className="password__textfield"
							label="Email"
							onChange={(e) => setPasswordResetEmail(e.target.value)}
						/>
						<Button variant="contained" className="password__button" onClick={handleForgotPassword}>
							SUBMIT
						</Button>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default Login;

const bigLetters = {
	fontWeight: "600",
	color: "white",
	fontSize: "64px",
	wordWrap: "break-word",
	lineHeight: "1",
	textShadow: "2px 2px 16px rgba(0, 0, 0, 0.5)",
};
